import { useTranslation } from 'react-i18next';
import LayoutAuth from '../../components/LayoutAuth';
import FormCreateNewPassword from './components/FormCreateNewPassword';
import { Helmet } from 'react-helmet-async';

const CreateNewPassword = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      <LayoutAuth
        linkHelperText={t('reset_password.linkHelperText')}
        linkHelperMessage={t('reset_password.linkHelperMessage')}
        linkHelper="/login"
        title={t('reset_password.title')}
      >
        <FormCreateNewPassword />
      </LayoutAuth>
    </>
  );
};
export default CreateNewPassword;
